import pRetry from "p-retry";
import client from "../external/open-api";
import { ApplicationError } from "../models/errors/application-error";
import delay from "delay";

export default abstract class BaseService {
    // Default retry count (can override per service)
    protected defaultRetries = 3;

    /**
     * Wraps a client call in retry logic.
     * Handles transient HTTP errors and network failures.
     */
    protected async withRetry<T>(fn: () => Promise<T>, retries?: number): Promise<T> {
        return pRetry(
            async () => {
                try {
                    const result = await fn();

                    const status = (result as any)?.response?.status
                    const retryableStatusCodes = [408, 429, 502, 503, 504];
                    if (status && retryableStatusCodes.includes(status)) {
                        throw new Error(`Transient HTTP error: ${status}`);
                    }

                    return result;
                } catch (err: any) {
                    // Network errors / fetch failures will be retried automatically
                    throw err;
                }
            },
            {
                retries: retries ?? this.defaultRetries,
                onFailedAttempt: async () => {
                    console.log('Waiting for 1 second before retrying');
                    await delay(1000);
                }
            },

        );
    }
}
